<template>
  <div class="modal">
    <div class="modal-content">
      <!-- モーダルを閉じるボタン -->
      <span class="close-button" @click="closeModal">&times;</span>

      <!-- 動的にメッセージを表示 -->
      <h3>{{ confirmationMessage }}</h3>
      <p>内容：{{ fileName }}</p>

      <!-- ボタングループ -->
      <div class="button-group">
        <button class="confirm-button" @click="confirmUpload">OK</button>
        <button class="confirm-button" @click="closeModal">キャンセル</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  props: {
    fileName: String, // ファイル名を受け取るプロパティ
    fileExists: Boolean, // ファイルの存在確認をするためのプロパティ
  },
  computed: {
    // メッセージを動的に生成するコンピューテッドプロパティ
    confirmationMessage() {
      // ファイルが存在するかどうかでメッセージを分岐
      return this.fileExists
        ? "以下の内容で更新いたしますか。"
        : "以下の内容で新規登録いたしますか。";
    },
  },
  methods: {
    // モーダルを閉じるメソッド
    closeModal() {
      this.$emit("close"); // 親コンポーネントに閉じるイベントを通知
    },
    // アップロード確認処理
    confirmUpload() {
      this.$emit("confirm"); // 親コンポーネントに確認イベントを通知
      this.closeModal(); // モーダルを閉じる
    },
  },
};
</script>

<style scoped>
/* モーダル全体のスタイル */
.modal {
  display: flex; /* フレックスボックスを使用して配置 */
  justify-content: center; /* 中央揃え */
  align-items: center; /* 垂直方向に中央揃え */
  position: fixed; /* 固定位置 */
  top: 0; /* 上端を画面の0に設定 */
  left: 0; /* 左端を画面の0に設定 */
  width: 100%; /* 幅を100%に設定 */
  height: 100%; /* 高さを100%に設定 */
  background: rgba(0, 0, 0, 0.5); /* 半透明の背景 */
}

/* モーダルコンテンツのスタイル */
.modal-content {
  background: white; /* モーダルの背景色を白に設定 */
  padding: 20px; /* 内部パディングを設定 */
  border-radius: 5px; /* 角を丸くする */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3); /* 影を与えて浮いて見えるデザイン */
  width: 80%; /* 幅を80%に設定 */
  max-width: 400px; /* 最大幅を指定（オプション） */
}

/* クローズボタンのスタイル */
.close-button {
  cursor: pointer; /* ポインターカーソルを設定 */
  float: right; /* 右寄せ */
}

/* ボタングループのスタイル */
.button-group {
  margin-top: 20px; /* ボタンの間にスペースを追加 */
  display: flex; /* フレックスボックスを使ってボタンを配置 */
  justify-content: flex-end; /* ボタンを右寄せ */
}

/* 確認ボタンのスタイル */
.confirm-button {
  flex: 1; /* ボタンが等しく広がるように設定 */
  max-width: 100px; /* 最大幅を指定（必要に応じて調整） */
  margin-right: 10px; /* ボタンの間にスペースを追加 */
  padding: 5px 0; /* 縦方向に均等なパディングを設定 */
  background-color: rgb(136, 174, 82); /* ボタンの背景色 */
  color: black; /* ボタンのテキスト色 */
  border: none; /* ボタンにボーダーを付けない */
  border-radius: 5px; /* ボタンの角を丸くする */
  cursor: pointer; /* ポインターカーソルを設定 */
}
</style>
